export default "__VITE_ASSET__Bmc1ObUP__"